module.exports = __webpack_public_path__ + "63b8e9c233b2d398bbc1897c800911c8.svg";